import { deleteAxios, postAxios, putAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";
import { formatPreferences } from "../OnBoarding/Onboarding.util";

export const MapPreferencesData = (data: any): PreferencesData => {
  const tripModality = filterOptimalRoute(data.data.preferences.optimalRoutes);
  const tripPreferencesLessWalk = filterRoutesTypes(
    data.data.preferences.routes,
    OptimalRoutesTypes.LEES_WALK
  );
  const tripPreferencesMoreTime = filterRoutesTypes(
    data.data.preferences.routes,
    OptimalRoutesTypes.MORE_TIME
  );
  const addressesPreferences = data.data.addresses;
  return {
    tripModality,
    tripPreferencesLessWalk,
    tripPreferencesMoreTime,
    addressesPreferences,
  };
};

export const initPreferencesData = () => {
  return {
    tripModality: "",
    tripPreferencesLessWalk: false,
    tripPreferencesMoreTime: false,
    addressesPreferences: [],
  };
};

export function mapPreferencesApiData(data: any,t:any) {
  let output: any = {
    preferences: {
      optimalRoutes: formatPreferences(data.tripModality,t),
      routes: formatRoutes(
        data.tripPreferencesLessWalk,
        data.tripPreferencesMoreTime
      ),
    },
  };
  return output;
}

export function mapAddressesApiData(
  data: any,
  addressType: string
): addressAPIObject {
  return {
    description: data.description,
    hafasId: data.hafasId,
    label: addressType,
  };
}

/**
 * @description function that returns the api call routes object
 * @param {boolean} lessWalk
 * @param {boolean} moreTime
 * @returns
 */
export const formatRoutes = (lessWalk: boolean, moreTime: boolean) => {
  let model = [
    {
      type: "LESS_WALKING_DISTANCE",
      enabled: false,
    },
    {
      type: "MORE_TIME_ON_TRANSFER",
      enabled: false,
    },
  ];

  if (lessWalk) model[0].enabled = true;
  if (moreTime) model[1].enabled = true;

  return model;
};

const filterOptimalRoute = (routes: any[]) => {
  const routeSelected = routes.find((elem) => elem.enabled);
  switch (routeSelected?.type) {
    case "SUSTAINABLE":
      return OptimalRoutesTypes.SUSTAINABLE;
    case "FAST":
      return OptimalRoutesTypes.FAST;
      case "DIRECT":
      return OptimalRoutesTypes.DIRECT;
  }
  return "";
};

const filterRoutesTypes = (routes: any[], name: string) => {
  const routeSelected = routes.find((elem) => {
    if (elem.type == name) return elem.enabled;
  });
  switch (routeSelected?.type) {
    case OptimalRoutesTypes.LEES_WALK:
      return OptimalRoutesTypes.LEES_WALK;
    case OptimalRoutesTypes.MORE_TIME:
      return OptimalRoutesTypes.MORE_TIME;
  }
  return false;
};

enum OptimalRoutesTypes {
  DIRECT = "1",
  FAST = "2",
  ECONOMIC = "3",
  SUSTAINABLE = "4",



  

}
enum OptimalRoutesTypes {
  LEES_WALK = "LESS_WALKING_DISTANCE",
  MORE_TIME = "MORE_TIME_ON_TRANSFER",
}

export interface addressAPIObject {
  label: string;
  hafasId: string;
  description: string;
}

export enum addressTypes {
  Work = "sys:OFFICE",
  Home = "sys:HOME",
}

export interface PreferencesData {
  tripModality: {};
  tripPreferencesLessWalk: {};
  tripPreferencesMoreTime: {};
  addressesPreferences: {};
}

export enum AdressesTypes {
  HOME = "sys:HOME",
  WORK = "sys:OFFICE",
}

export const AdressesTypesByLiteral: any = {
  Work: AdressesTypes.WORK,
  Home: AdressesTypes.HOME,
};

export function putUserAdresses(
  data: any,
  id: string,
  callback?: Function,
  errorCallback?: Function
) {
  return putAxios(
    apiNames.PROFMANAG,
    true,
    "/customers/profiles/addresses/" + id,
    data
  )
    .then((response: any) => {
      if (callback) callback(response);
    })
    .catch((error: any) => {
      if (errorCallback) errorCallback(error);
    });
}
export function postUserAdresses(
  data: any,
  callback?: Function,
  errorCallback?: Function
) {
  return postAxios(
    apiNames.PROFMANAG,
    true,
    "/customers/profiles/addresses",
    data
  )
    .then((response: any) => {
      if (callback) callback(response);
    })
    .catch((error: any) => {
      if (errorCallback) errorCallback(error);
    });
}

export function deleteUserAdresses(
  id: string,
  callback?: Function,
  errorCallback?: Function
) {
  return deleteAxios(
    apiNames.PROFMANAG,
    true,
    "/customers/profiles/addresses/" + id
  )
    .then((response: any) => {
      if (callback) callback(response);
    })
    .catch((error: any) => {
      if (errorCallback) errorCallback(error);
    });
}

export function DeleteAdressModalLiterals(t: any) {
  return {
    literals: {
      title: t("literals.title"),
      desc: t("literals.desc"),
      cancelbutton: t("literals.cancelbutton"),
      okbutton: t("literals.okbutton"),
    },
  };
}


export function PMyPreferenesLiterals(t: any) {
  return {
    title: t("PMyPreferenesLiterals.title"),
    sec1title:t("PMyPreferenesLiterals.sec1title"),
    sec1desc: t("PMyPreferenesLiterals.sec1desc"),
    switchhorizontal: {slot1: t("PMyPreferenesLiterals.switchhorizontal.slot1"), slot2: t("PMyPreferenesLiterals.switchhorizontal.slot2"), slot4: t("PMyPreferenesLiterals.switchhorizontal.slot4") },
    sec1desc2: [
      t("PMyPreferenesLiterals.sec1desc2.0"),
      t("PMyPreferenesLiterals.sec1desc2.1"),
      t("PMyPreferenesLiterals.sec1desc2.3"),
    ],
    sec1desc3:[
      t("PMyPreferenesLiterals.sec1desc3.0"),
      t("PMyPreferenesLiterals.sec1desc3.1"),
      t("PMyPreferenesLiterals.sec1desc3.3"),
    ],
    sec2title: t("PMyPreferenesLiterals.sec2title"),
    sec2desc: t("PMyPreferenesLiterals.sec2desc"),
    switchCard: [
      { title: t("PMyPreferenesLiterals.switchCard.0.title"), desc: t("PMyPreferenesLiterals.switchCard.0.desc")},
      { title: t("PMyPreferenesLiterals.switchCard.1.title"), desc: t("PMyPreferenesLiterals.switchCard.1.desc") },
    ],
    sec3title: t("PMyPreferenesLiterals.sec3title"),
    sec3desc:t("PMyPreferenesLiterals.sec3desc"),
    sec4title: t("PMyPreferenesLiterals.sec4title"),
    sec4desc: t("PMyPreferenesLiterals.sec4desc"),
    cardDirection: [
      { text: t("PMyPreferenesLiterals.cardDirection.0.text"), subtext: t("PMyPreferenesLiterals.cardDirection.0.subtext"), iconAlt: t("PMyPreferenesLiterals.cardDirection.0.iconAlt"), iconType: t("PMyPreferenesLiterals.cardDirection.0.iconAlt")},
      { text: t("PMyPreferenesLiterals.cardDirection.1.text"), subtext: t("PMyPreferenesLiterals.cardDirection.1.subtext"), iconAlt: t("PMyPreferenesLiterals.cardDirection.1.iconAlt"), iconType: t("PMyPreferenesLiterals.cardDirection.1.iconAlt")},
    ],
    button: t("PMyPreferenesLiterals.button"),
  };
}

export function getFavAdressLiterals(t: any) {
  return{
    title: t("favAdressLiterals.title"),
    titleEdit: t("favAdressLiterals.titleEdit"),
    searchtext: t("favAdressLiterals.searchtext"),
    recently: t("favAdressLiterals.recently"),
    erasebutton: t("favAdressLiterals.erasebutton"),
    cancelbutton: t("favAdressLiterals.cancelbutton"),
    addbutton: t("favAdressLiterals.addbutton"),
  }
}
